<app-side-menu>
  <div class="b2b-contracts-driver-form-container">
    <!-- Loading State -->
    <app-loading [show]="isLoading" message="Carregando condutor..."></app-loading>

    <!-- Content -->
    <div *ngIf="!isLoading" class="form-content">
      <!-- Header -->
      <div class="header">
        <div class="title-section">
          <button class="btn-back" (click)="navigateBack()">
            <i class="fas fa-arrow-left"></i>
          </button>
          <div class="title-info">
            <h1>
              <i class="fas fa-user-edit me-2"></i>
              {{ isEditMode ? 'Editar Condutor' : 'Novo Condutor' }}
            </h1>
            <p *ngIf="contractNumber">
              Contrato: {{ contractNumber }} - {{ contractName }}
            </p>
          </div>
        </div>
        <div class="action-buttons">
          <button class="btn btn-secondary" (click)="navigateBack()">
            <i class="fas fa-arrow-left me-2"></i>
            Cancelar
          </button>
        </div>
      </div>

      <!-- Form -->
      <form [formGroup]="driverForm" (ngSubmit)="onSubmit()">
        <div class="card mb-4">
          <div class="card-header text-white">
            <h3>
              <i class="fas fa-user me-2"></i>
              Informações Pessoais
            </h3>
          </div>
          <div class="card-body">
            <div class="row g-3">
              <div class="col-md-12">
                <label class="form-label">Nome <span class="text-danger">*</span></label>
                <input
                  type="text"
                  class="form-control"
                  formControlName="name"
                  [class.is-invalid]="driverForm.get('name')?.invalid && driverForm.get('name')?.touched"
                  placeholder="Digite o nome completo">
                <div class="invalid-feedback" *ngIf="driverForm.get('name')?.invalid && driverForm.get('name')?.touched">
                  <span *ngIf="driverForm.get('name')?.errors?.['required']">Nome é obrigatório</span>
                  <span *ngIf="driverForm.get('name')?.errors?.['minlength']">Nome deve ter pelo menos 3 caracteres</span>
                </div>
              </div>

              <div class="col-md-6">
                <label class="form-label">CPF <span class="text-danger">*</span></label>
                <input
                  type="text"
                  class="form-control"
                  formControlName="driverCpf"
                  (input)="formatCpf($event)"
                  (blur)="onCpfBlur()"
                  [class.is-invalid]="driverForm.get('driverCpf')?.invalid && driverForm.get('driverCpf')?.touched"
                  placeholder="000.000.000-00"
                  maxlength="14">
                <div class="invalid-feedback" *ngIf="driverForm.get('driverCpf')?.invalid && driverForm.get('driverCpf')?.touched">
                  <span *ngIf="driverForm.get('driverCpf')?.errors?.['required']">CPF é obrigatório</span>
                  <span *ngIf="driverForm.get('driverCpf')?.errors?.['pattern']">CPF inválido</span>
                </div>
              </div>

              <div class="col-md-6">
                <label class="form-label">CNH</label>
                <input
                  type="text"
                  class="form-control"
                  formControlName="driverCnh"
                  (input)="formatCnh($event)"
                  placeholder="Número da CNH"
                  maxlength="20">
              </div>

              <div class="col-md-3">
                <label class="form-label">Categoria CNH</label>
                <input type="text" class="form-control" formControlName="cnhCategory" placeholder="Ex: A, AB" maxlength="10">
              </div>
              <div class="col-md-3">
                <label class="form-label">Vencimento CNH</label>
                <input type="date" class="form-control" formControlName="cnhExpirationDate">
              </div>

              <div class="col-md-4">
                <label class="form-label">Matrícula RH</label>
                <input type="text" class="form-control" formControlName="employeeRegistration" placeholder="Matrícula">
              </div>
              <div class="col-md-4">
                <label class="form-label">Admissão</label>
                <input type="date" class="form-control" formControlName="admissionDate">
              </div>
              <div class="col-md-4">
                <label class="form-label">Nascimento</label>
                <input type="date" class="form-control" formControlName="birthDate">
              </div>

              <div class="col-md-6">
                <label class="form-label">Coordenador</label>
                <input type="text" class="form-control" formControlName="coordinatorName" placeholder="Nome do coordenador">
              </div>
              <div class="col-md-6">
                <label class="form-label">Líder</label>
                <input type="text" class="form-control" formControlName="leaderName" placeholder="Nome do líder">
              </div>

              <div class="col-md-6">
                <label class="form-label">Telefone</label>
                <input
                  type="text"
                  class="form-control"
                  formControlName="phone"
                  (input)="formatPhone($event)"
                  (blur)="onPhoneBlur()"
                  placeholder="(00) 00000-0000"
                  maxlength="15">
              </div>

              <div class="col-md-6">
                <label class="form-label">Email</label>
                <input
                  type="email"
                  class="form-control"
                  formControlName="email"
                  placeholder="email@exemplo.com">
              </div>

              <div class="col-md-12">
                <label class="form-label">Endereço (texto livre)</label>
                <input
                  type="text"
                  class="form-control"
                  formControlName="address"
                  placeholder="Digite o endereço completo">
              </div>

              <div class="col-md-6">
                <label class="form-label">Rua</label>
                <input type="text" class="form-control" formControlName="addressStreet">
              </div>
              <div class="col-md-2">
                <label class="form-label">Número</label>
                <input type="text" class="form-control" formControlName="addressNumber">
              </div>
              <div class="col-md-4">
                <label class="form-label">Bairro</label>
                <input type="text" class="form-control" formControlName="addressNeighborhood">
              </div>
              <div class="col-md-3">
                <label class="form-label">CEP</label>
                <input type="text" class="form-control" formControlName="addressZipCode" placeholder="00000-000">
              </div>
              <div class="col-md-5">
                <label class="form-label">Cidade</label>
                <input type="text" class="form-control" formControlName="addressCity">
              </div>
              <div class="col-md-4">
                <label class="form-label">UF</label>
                <input type="text" class="form-control" formControlName="addressState" maxlength="2" placeholder="SP">
              </div>
            </div>
          </div>
        </div>

        <app-b2b-driver-documents
          [contractId]="contractId"
          [driverId]="driverId"
          [cnhDocumentUrl]="cnhDocumentUrl"
          [termoResponsabilidadeUrl]="termoResponsabilidadeUrl"
          [lockedMessage]="isEditMode ? null : 'Salve o condutor primeiro para enviar CNH e termo de responsabilidade.'"
          (documentsUpdated)="onDocumentsUpdated($event)">
        </app-b2b-driver-documents>

        <!-- Botões de Ação -->
        <div class="form-actions">
          <button type="button" class="btn btn-secondary" (click)="navigateBack()" [disabled]="isSubmitting">
            <i class="fas fa-times me-2"></i>
            Cancelar
          </button>
          <button type="submit" class="btn btn-primary" [disabled]="isSubmitting || driverForm.invalid">
            <i class="fas fa-save me-2"></i>
            {{ isSubmitting ? 'Salvando...' : 'Salvar' }}
          </button>
        </div>
      </form>
    </div>
  </div>
</app-side-menu>
